import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ScriptTemplate, EventConfig } from '../../interfaces/event-script.models';

/**
 * Preview em linguagem natural do comportamento configurado
 */
@Component({
  selector: 'app-behavior-preview',
  templateUrl: './behavior-preview.component.html',
  styleUrls: ['./behavior-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BehaviorPreviewComponent {
  @Input() template: ScriptTemplate | null = null;
  @Input() config: Record<string, any> | null = null;
  @Input() eventConfig: EventConfig | null = null;

  /**
   * Gera texto de preview humanizado
   */
  get previewText(): string {
    if (!this.eventConfig || !this.eventConfig.description) {
      return 'Configure um template para ver o preview do comportamento.';
    }

    return this.eventConfig.description;
  }

  /**
   * Verifica se há configuração válida
   */
  get hasValidConfig(): boolean {
    return !!this.eventConfig && !!this.eventConfig.description;
  }
}



